// extracted by mini-css-extract-plugin
export default {"cardHead":"CardHead_cardHead__c6tkz","cardHeadLeft":"CardHead_cardHeadLeft__lZBKk","scoreBox":"CardHead_scoreBox__kJSqq"};